import { auth,db } from "./main";
import { doc, setDoc, getDoc, collection, query, where, getDocs, updateDoc, addDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { getSubscriptionInfo } from "./ttapi";

const resultRef = collection(db,"p2_results");

const fetchRecommendation = async(docID)=>{
    let recommend = {
        lifestyle:"",
        fitness: "",
        supplement:""
    };
    let recommendResp = await new Promise((resolve,reject)=>{
        onAuthStateChanged(auth,async(user)=>{
            if(user){
                const recRef = doc(db,"Recommendations",docID);
                const recSnap = await getDoc(recRef);
                if (recSnap.exists()){
                    recommend = {
                        lifestyle: recSnap.data().col1,
                        fitness:recSnap.data().col2,
                        supplement:recSnap.data().col3
                    }
                }
            }
            resolve(recommend)
        })
    })
    recommend = recommendResp;
    return recommend
}

export const updateVerifyScanRecord = async()=>{
    let recordVerified = false;
    let updateScanResp = await new Promise((resolve,reject)=>{
        onAuthStateChanged(auth,async(user)=>{
            if(user){
                let checkAuth = await getSubscriptionInfo();
                if (checkAuth.status){
                    let customerID = localStorage.getItem('customerID')
                    const userRef = doc(db,"users",customerID);
                    const userSnap = await getDoc(userRef);
                    if(userSnap.exists()){
                        let latestRecord = userSnap.data().resultDoc;
                        let docRef = doc(db,"p2_results",latestRecord);
                        try{
                            const snapShot = await getDoc(docRef);
                            if (snapShot.exists()){
                                await updateDoc(docRef,{
                                    verified:true,
                                })
                                await updateDoc(userRef,{
                                    prevDoc:latestRecord,
                                })
                                recordVerified = true;
                                await fetchAndUpdateDailyDataTable(snapShot.data())
                            }
                        }catch(e){
                            recordVerified = false;
                        }
                    }else{
                        recordVerified = false;
                    }
                }else{
                    recordVerified = false;
                }
            }
            resolve(recordVerified)
        })
    })
    recordVerified = updateScanResp
    return recordVerified
}

export const fetchAndUpdateDailyDataTable = async(latestData)=>{
    let dailyRef = collection(db,"daily_data");

    let dailyQuery = query(dailyRef,where("userID","==",latestData.userID),where("date","==",latestData.date));

    let dailyDocSnapShot = await getDocs(dailyQuery);
    // console.log('Daily Doc Snapshot Len : ',dailyDocSnapShot.length)
    
    if (dailyDocSnapShot.docs.length != 0){
        let dailyDocRef = doc(db,"daily_data",dailyDocSnapShot.docs[0].id)
        let dailyDataLog = {
            hrScore:Number(averageValue([latestData.hrScore,dailyDocSnapShot.docs[0].data().hrScore]).toFixed(1)),
            rrScore:Number(averageValue([latestData.rrScore,dailyDocSnapShot.docs[0].data().rrScore]).toFixed(1)),
            spo2Score:Number(averageValue([latestData.spo2Score,dailyDocSnapShot.docs[0].data().spo2Score]).toFixed(1)),
            bpScore:Number(averageValue([latestData.bpScore,dailyDocSnapShot.docs[0].data().bpScore]).toFixed(1)),
            bsScore:Number(averageValue([latestData.bsScore,dailyDocSnapShot.docs[0].data().bsScore]).toFixed(1)),
            bcScore:Number(averageValue([latestData.bcScore,dailyDocSnapShot.docs[0].data().bcScore]).toFixed(1)),
            basicScore:Number(averageValue([latestData.basicScore,dailyDocSnapShot.docs[0].data().basicScore]).toFixed(1)),
            coreScore:Number(averageValue([latestData.coreScore,dailyDocSnapShot.docs[0].data().coreScore]).toFixed(1)),
            healthTipScore:Number(averageValue([latestData.healthTipScore,dailyDocSnapShot.docs[0].data().healthTipScore]).toFixed(1)),
            healthnessScore:Number(averageValue([latestData.healthnessScore,dailyDocSnapShot.docs[0].data().healthnessScore]).toFixed(1)),
            stressScore:Number(averageValue([latestData.stressScore,dailyDocSnapShot.docs[0].data().stressScore]).toFixed(1)),
            fatigueScore:Number(averageValue([latestData.fatigueScore,dailyDocSnapShot.docs[0].data().fatigueScore]).toFixed(1)),
            boneScore:Number(averageValue([latestData.boneScore,dailyDocSnapShot.docs[0].data().boneScore]).toFixed(1)),
            immuneScore:Number(averageValue([latestData.immuneScore,dailyDocSnapShot.docs[0].data().immuneScore]).toFixed(1)),
            glucoseMetabolismScore:Number(averageValue([latestData.glucoseMetabolismScore,dailyDocSnapShot.docs[0].data().glucoseMetabolismScore]).toFixed(1)),
            cholMetabolismScore:Number(averageValue([latestData.cholMetabolismScore,dailyDocSnapShot.docs[0].data().cholMetabolismScore]).toFixed(1)),
            o2MetabolismScore:Number(averageValue([latestData.o2MetabolismScore,dailyDocSnapShot.docs[0].data().o2MetabolismScore]).toFixed(1)),
            metabolismScore:Number(averageValue([latestData.metabolismScore,dailyDocSnapShot.docs[0].data().metabolismScore]).toFixed(1)),
            easternMedicineScore:Number(averageValue([latestData.easternMedicineScore,dailyDocSnapShot.docs[0].data().easternMedicineScore]).toFixed(1)),
            yinScore:Number(averageValue([latestData.yinScore,dailyDocSnapShot.docs[0].data().yinScore]).toFixed(1)),
            yangScore:Number(averageValue([latestData.yangScore,dailyDocSnapShot.docs[0].data().yangScore]).toFixed(1)),
            sensitivityScore:Number(averageValue([latestData.sensitivityScore,dailyDocSnapShot.docs[0].data().sensitivityScore]).toFixed(1)),
            circulationScore:Number(averageValue([latestData.circulationScore,dailyDocSnapShot.docs[0].data().circulationScore]).toFixed(1)),
            fitnessScore:Number(averageValue([latestData.fitnessScore,dailyDocSnapShot.docs[0].data().fitnessScore]).toFixed(1)),
            dietScore:Number(averageValue([latestData.dietScore,dailyDocSnapShot.docs[0].data().dietScore]).toFixed(1)),
            vitaminScore:Number(averageValue([latestData.vitaminScore,dailyDocSnapShot.docs[0].data().vitaminScore]).toFixed(1)),
            vitaBScore:Number(averageValue([latestData.vitaBScore,dailyDocSnapShot.docs[0].data().vitaBScore]).toFixed(1)),
            vitaB3Score:Number(averageValue([latestData.vitaB3Score,dailyDocSnapShot.docs[0].data().vitaB3Score]).toFixed(1)),
            vitaB9Score:Number(averageValue([latestData.vitaB9Score,dailyDocSnapShot.docs[0].data().vitaB9Score]).toFixed(1)),
            vitaB12Score:Number(averageValue([latestData.vitaB12Score,dailyDocSnapShot.docs[0].data().vitaB12Score]).toFixed(1)),
            vitaCScore:Number(averageValue([latestData.vitaCScore,dailyDocSnapShot.docs[0].data().vitaCScore]).toFixed(1)),
            vitaDScore:Number(averageValue([latestData.vitaDScore,dailyDocSnapShot.docs[0].data().vitaDScore]).toFixed(1)),
            vitaEScore:Number(averageValue([latestData.vitaEScore,dailyDocSnapShot.docs[0].data().vitaEScore]).toFixed(1)),
            mineralScore:Number(averageValue([latestData.mineralScore,dailyDocSnapShot.docs[0].data().mineralScore]).toFixed(1)),
            caScore:Number(averageValue([latestData.caScore,dailyDocSnapShot.docs[0].data().caScore]).toFixed(1)),
            mgScore:Number(averageValue([latestData.mgScore,dailyDocSnapShot.docs[0].data().mgScore]).toFixed(1)),
            feScore:Number(averageValue([latestData.feScore,dailyDocSnapShot.docs[0].data().feScore]).toFixed(1)),
            phScore:Number(averageValue([latestData.phScore,dailyDocSnapShot.docs[0].data().phScore]).toFixed(1)),
            probioticsScore:Number(averageValue([latestData.probioticsScore,dailyDocSnapShot.docs[0].data().probioticsScore]).toFixed(1)),
            lTheanineScore:Number(averageValue([latestData.lTheanineScore,dailyDocSnapShot.docs[0].data().lTheanineScore]).toFixed(1)),
            policoSanolScore:Number(averageValue([latestData.policoSanolScore,dailyDocSnapShot.docs[0].data().policoSanolScore]).toFixed(1)),
            omega3Score:Number(averageValue([latestData.omega3Score,dailyDocSnapShot.docs[0].data().omega3Score]).toFixed(1)),
            redYeastRice:Number(averageValue([latestData.redYeastRice,dailyDocSnapShot.docs[0].data().redYeastRice]).toFixed(1)),
            nutrientScore:Number(averageValue([latestData.nutrientScore,dailyDocSnapShot.docs[0].data().nutrientScore]).toFixed(1)),
            wellnessScore:Number(averageValue([latestData.wellnessScore,dailyDocSnapShot.docs[0].data().wellnessScore]).toFixed(1)),
            skinHealthScore:Number(averageValue([latestData.skinHealthScore,dailyDocSnapShot.docs[0].data().skinHealthScore]).toFixed(1)),
            cleanserScore:Number(averageValue([latestData.cleanserScore,dailyDocSnapShot.docs[0].data().cleanserScore]).toFixed(1)),
            moisturizerScore:Number(averageValue([latestData.moisturizerScore,dailyDocSnapShot.docs[0].data().moisturizerScore]).toFixed(1)),
            sunScreenScore:Number(averageValue([latestData.sunScreenScore,dailyDocSnapShot.docs[0].data().sunScreenScore]).toFixed(1)),
            exfoliantsScore:Number(averageValue([latestData.exfoliantsScore,dailyDocSnapShot.docs[0].data().exfoliantsScore]).toFixed(1)),
            antiAgingScore:Number(averageValue([latestData.antiAgingScore,dailyDocSnapShot.docs[0].data().antiAgingScore]).toFixed(1)),
            brighteningScore:Number(averageValue([latestData.brighteningScore,dailyDocSnapShot.docs[0].data().brighteningScore]).toFixed(1)),
            acneScore:Number(averageValue([latestData.acneScore,dailyDocSnapShot.docs[0].data().acneScore]).toFixed(1)),
            soothingScore:Number(averageValue([latestData.soothingScore,dailyDocSnapShot.docs[0].data().soothingScore]).toFixed(1)),
        }
        await updateDoc(dailyDocRef,dailyDataLog)
        await fetchAndUpdateWeeklyDataTable(dailyDataLog,latestData.userID,latestData.date)
    }else{
        let dailyDataLog = {
            userID:latestData.userID,
            date:latestData.date,
            hrScore:latestData.hrScore,
            rrScore:latestData.rrScore,
            spo2Score:latestData.spo2Score,
            bpScore:latestData.bpScore,
            bsScore:latestData.bsScore,
            bcScore:latestData.bcScore,
            basicScore:latestData.basicScore,
            coreScore:latestData.coreScore,
            healthTipScore:latestData.healthTipScore,
            healthnessScore:latestData.healthnessScore,
            stressScore:latestData.stressScore,
            fatigueScore:latestData.fatigueScore,
            boneScore:latestData.boneScore,
            immuneScore:latestData.immuneScore,
            glucoseMetabolismScore:latestData.glucoseMetabolismScore,
            cholMetabolismScore:latestData.cholMetabolismScore,
            o2MetabolismScore:latestData.o2MetabolismScore,
            metabolismScore:latestData.metabolismScore,
            easternMedicineScore:latestData.easternMedicineScore,
            yinScore:latestData.yinScore,
            yangScore:latestData.yangScore,
            sensitivityScore:latestData.sensitivityScore,
            circulationScore:latestData.circulationScore,
            fitnessScore:latestData.fitnessScore,
            dietScore:latestData.dietScore,
            vitaminScore:latestData.vitaminScore,
            vitaBScore:latestData.vitaBScore,
            vitaB3Score:latestData.vitaB3Score,
            vitaB9Score:latestData.vitaB9Score,
            vitaB12Score:latestData.vitaB12Score,
            vitaCScore:latestData.vitaCScore,
            vitaDScore:latestData.vitaDScore,
            vitaEScore:latestData.vitaEScore,
            mineralScore:latestData.mineralScore,
            caScore:latestData.caScore,
            mgScore:latestData.mgScore,
            feScore:latestData.feScore,
            phScore:latestData.phScore,
            probioticsScore:latestData.probioticsScore,
            lTheanineScore:latestData.lTheanineScore,
            policoSanolScore:latestData.policoSanolScore,
            omega3Score:latestData.omega3Score,
            redYeastRice:latestData.redYeastRice,
            nutrientScore:latestData.nutrientScore,
            wellnessScore:latestData.wellnessScore,
            skinHealthScore:latestData.skinHealthScore,
            cleanserScore:latestData.cleanserScore,
            moisturizerScore:latestData.moisturizerScore,
            sunScreenScore:latestData.sunScreenScore,
            exfoliantsScore:latestData.exfoliantsScore,
            antiAgingScore:latestData.antiAgingScore,
            brighteningScore:latestData.brighteningScore,
            acneScore:latestData.acneScore,
            soothingScore:latestData.soothingScore,
        }
        let dailyDocRef = await addDoc(dailyRef,dailyDataLog)
        await fetchAndUpdateWeeklyDataTable(dailyDataLog,latestData.userID,latestData.date)
    }
}
const createObjectScoreDict = (wKey,score)=>{
    let dicts = {
        0:0,
        1:0,
        2:0,
        3:0,
        4:0,
        5:0,
        6:0
        // 7:0
    }
    dicts[wKey]=score
    return dicts
}

const updateObjectScoreDict = (wKey,score,dicts)=>{
    dicts[wKey]=score
    return dicts
}


export const fetchAndUpdateWeeklyDataTable = async (latestData,userID,date)=>{
    let dateResp = dayOfWeek(date); // returns start_date and end_date 
    let weeklyRef = collection(db,"weekly_data");
    let weeklyQuery = query(weeklyRef,where("userID","==",userID),where("startDate","==",dateResp.start))
    let weeklyDocSnapShot = await getDocs(weeklyQuery);
    let weekKey = dateResp.currDay;
    if (weeklyDocSnapShot.docs.length != 0){
        // updating already present record 
        let weeklyDocRef = doc(db,'weekly_data',weeklyDocSnapShot.docs[0].id)
        let weeklyCurrentData = weeklyDocSnapShot.docs[0].data()
        let weeklyLog = {
            hrScore:updateObjectScoreDict(weekKey,latestData.hrScore,weeklyCurrentData.hrScore),
            rrScore:updateObjectScoreDict(weekKey,latestData.rrScore ,weeklyCurrentData.rrScore),
            spo2Score:updateObjectScoreDict(weekKey,latestData.spo2Score ,weeklyCurrentData.spo2Score),
            bpScore:updateObjectScoreDict(weekKey,latestData.bpScore ,weeklyCurrentData.bpScore),
            bsScore:updateObjectScoreDict(weekKey,latestData.bsScore  ,weeklyCurrentData.bsScore),
            bcScore:updateObjectScoreDict(weekKey,latestData.bcScore ,weeklyCurrentData.bcScore),
            basicScore: updateObjectScoreDict(weekKey,latestData.basicScore  ,weeklyCurrentData.basicScore),
            coreScore: updateObjectScoreDict(weekKey,latestData.coreScore   ,weeklyCurrentData.coreScore),
            healthTipScore:updateObjectScoreDict(weekKey,latestData.healthTipScore ,weeklyCurrentData.healthTipScore),
            healthnessScore: updateObjectScoreDict(weekKey,latestData.healthnessScore  ,weeklyCurrentData.healthnessScore),
            stressScore: updateObjectScoreDict(weekKey,latestData.stressScore  ,weeklyCurrentData.stressScore),
            fatigueScore: updateObjectScoreDict(weekKey,latestData.fatigueScore ,weeklyCurrentData.fatigueScore),
            boneScore:  updateObjectScoreDict(weekKey,latestData.boneScore  ,weeklyCurrentData.boneScore),
            immuneScore: updateObjectScoreDict(weekKey,latestData.immuneScore  ,weeklyCurrentData.immuneScore),
            glucoseMetabolismScore: updateObjectScoreDict(weekKey,latestData.glucoseMetabolismScore ,weeklyCurrentData.glucoseMetabolismScore),
            cholMetabolismScore: updateObjectScoreDict(weekKey,latestData.cholMetabolismScore,weeklyCurrentData.cholMetabolismScore),
            o2MetabolismScore:  updateObjectScoreDict(weekKey,latestData.o2MetabolismScore   ,weeklyCurrentData.o2MetabolismScore),
            metabolismScore:   updateObjectScoreDict(weekKey,latestData.metabolismScore  ,weeklyCurrentData.metabolismScore),
            easternMedicineScore: updateObjectScoreDict(weekKey,latestData.easternMedicineScore   ,weeklyCurrentData.easternMedicineScore),
            yinScore:    updateObjectScoreDict(weekKey,latestData.yinScore  ,weeklyCurrentData.yinScore),
            yangScore:    updateObjectScoreDict(weekKey,latestData.yangScore  ,weeklyCurrentData.yangScore),
            sensitivityScore: updateObjectScoreDict(weekKey,latestData.sensitivityScore   ,weeklyCurrentData.sensitivityScore),
            circulationScore: updateObjectScoreDict(weekKey,latestData.circulationScore  ,weeklyCurrentData.circulationScore),
            fitnessScore:  updateObjectScoreDict(weekKey,latestData.fitnessScore  ,weeklyCurrentData.fitnessScore),
            dietScore:   updateObjectScoreDict( weekKey,latestData.dietScore    ,weeklyCurrentData.dietScore),
            vitaminScore: updateObjectScoreDict( weekKey,latestData.vitaminScore ,weeklyCurrentData.vitaminScore),
            vitaBScore:   updateObjectScoreDict(weekKey,latestData.vitaBScore  ,weeklyCurrentData.vitaBScore),
            vitaB3Score: updateObjectScoreDict(weekKey,latestData.vitaB3Score ,weeklyCurrentData.vitaB3Score),
            vitaB9Score:  updateObjectScoreDict(weekKey,latestData.vitaB9Score  ,weeklyCurrentData.vitaB9Score),
            vitaB12Score: updateObjectScoreDict(weekKey,latestData.vitaB12Score  ,weeklyCurrentData.vitaB12Score),
            vitaCScore:  updateObjectScoreDict(weekKey,latestData.vitaCScore  ,weeklyCurrentData.vitaCScore),
            vitaDScore:  updateObjectScoreDict(weekKey,latestData.vitaDScore ,weeklyCurrentData.vitaDScore),
            vitaEScore:  updateObjectScoreDict(weekKey,latestData.vitaEScore  ,weeklyCurrentData.vitaEScore),
            mineralScore: updateObjectScoreDict(weekKey,latestData.mineralScore  ,weeklyCurrentData.mineralScore),
            caScore:    updateObjectScoreDict(weekKey,latestData.caScore ,weeklyCurrentData.caScore),
            mgScore:   updateObjectScoreDict(weekKey,latestData.mgScore  ,weeklyCurrentData.mgScore),
            feScore:   updateObjectScoreDict(weekKey,latestData.feScore ,weeklyCurrentData.feScore),
            phScore:   updateObjectScoreDict(weekKey,latestData.phScore ,weeklyCurrentData.phScore),
            probioticsScore: updateObjectScoreDict(               weekKey,latestData.probioticsScore ,weeklyCurrentData.probioticsScore),
            lTheanineScore: updateObjectScoreDict(               weekKey,latestData.lTheanineScore  ,weeklyCurrentData.lTheanineScore),
            policoSanolScore: updateObjectScoreDict(               weekKey,latestData.policoSanolScore  ,weeklyCurrentData.policoSanolScore),
            omega3Score:   updateObjectScoreDict(             weekKey,latestData.omega3Score   ,weeklyCurrentData.omega3Score),
            redYeastRice:   updateObjectScoreDict(             weekKey,latestData.redYeastRice  ,weeklyCurrentData.redYeastRice),
            nutrientScore: updateObjectScoreDict(               weekKey,latestData.nutrientScore ,weeklyCurrentData.nutrientScore),
            wellnessScore: updateObjectScoreDict(               weekKey,latestData.wellnessScore ,weeklyCurrentData.wellnessScore),
            skinHealthScore: updateObjectScoreDict(               weekKey,latestData.skinHealthScore ,weeklyCurrentData.skinHealthScore),
            cleanserScore:   updateObjectScoreDict(             weekKey,latestData.cleanserScore ,weeklyCurrentData.cleanserScore),
            moisturizerScore:  updateObjectScoreDict(              weekKey,latestData.moisturizerScore ,weeklyCurrentData.moisturizerScore),
            sunScreenScore:  updateObjectScoreDict(              weekKey,latestData.sunScreenScore  ,weeklyCurrentData.sunScreenScore),
            exfoliantsScore: updateObjectScoreDict(               weekKey,latestData.exfoliantsScore  ,weeklyCurrentData.exfoliantsScore),
            antiAgingScore:  updateObjectScoreDict(              weekKey,latestData.antiAgingScore ,weeklyCurrentData.antiAgingScore),
            brighteningScore: updateObjectScoreDict(               weekKey,latestData.brighteningScore ,weeklyCurrentData.brighteningScore),
            acneScore:     updateObjectScoreDict(           weekKey,latestData.acneScore  ,weeklyCurrentData.acneScore),
            soothingScore:   updateObjectScoreDict(             weekKey,latestData.soothingScore  ,weeklyCurrentData.soothingScore),
        }
        await updateDoc(weeklyDocRef,weeklyLog)
    }else{
        // create a weekly record 
        let weeklyLog = {
            userID:userID,
            startDate:dateResp.start,
            endDate:dateResp.end,
            hrScore:createObjectScoreDict(weekKey,latestData.hrScore),
            rrScore:createObjectScoreDict(weekKey,latestData.rrScore            ),
            spo2Score:createObjectScoreDict(weekKey,latestData.spo2Score            ),
            bpScore:createObjectScoreDict(weekKey,latestData.bpScore            ),
            bsScore:createObjectScoreDict(weekKey,latestData.bsScore            ),
            bcScore:createObjectScoreDict(weekKey,latestData.bcScore            ),
            basicScore: createObjectScoreDict(weekKey,latestData.basicScore            ),
            coreScore: createObjectScoreDict(weekKey,latestData.coreScore            ),
            healthTipScore:createObjectScoreDict(weekKey,latestData.healthTipScore            ),
            healthnessScore: createObjectScoreDict(weekKey,latestData.healthnessScore            ),
            stressScore: createObjectScoreDict(weekKey,latestData.stressScore            ),
            fatigueScore: createObjectScoreDict(weekKey,latestData.fatigueScore            ),
            boneScore:  createObjectScoreDict(weekKey,latestData.boneScore            ),
            immuneScore: createObjectScoreDict(weekKey,latestData.immuneScore            ),
            glucoseMetabolismScore: createObjectScoreDict(weekKey,latestData.glucoseMetabolismScore            ),
            cholMetabolismScore: createObjectScoreDict(weekKey,latestData.cholMetabolismScore            ),
            o2MetabolismScore:  createObjectScoreDict(weekKey,latestData.o2MetabolismScore            ),
            metabolismScore:   createObjectScoreDict(weekKey,latestData.metabolismScore            ),
            easternMedicineScore: createObjectScoreDict(weekKey,latestData.easternMedicineScore            ),
            yinScore:    createObjectScoreDict(weekKey,latestData.yinScore            ),
            yangScore:    createObjectScoreDict(weekKey,latestData.yangScore            ),
            sensitivityScore: createObjectScoreDict(weekKey,latestData.sensitivityScore            ),
            circulationScore: createObjectScoreDict(weekKey,latestData.circulationScore            ),
            fitnessScore:  createObjectScoreDict(weekKey,latestData.fitnessScore            ),
            dietScore:   createObjectScoreDict( weekKey,latestData.dietScore            ),
            vitaminScore: createObjectScoreDict( weekKey,latestData.vitaminScore            ),
            vitaBScore:   createObjectScoreDict(weekKey,latestData.vitaBScore            ),
            vitaB3Score: createObjectScoreDict(weekKey,latestData.vitaB3Score            ),
            vitaB9Score:  createObjectScoreDict(weekKey,latestData.vitaB9Score            ),
            vitaB12Score: createObjectScoreDict(weekKey,latestData.vitaB12Score            ),
            vitaCScore:  createObjectScoreDict(weekKey,latestData.vitaCScore            ),
            vitaDScore:  createObjectScoreDict(weekKey,latestData.vitaDScore            ),
            vitaEScore:  createObjectScoreDict(weekKey,latestData.vitaEScore            ),
            mineralScore: createObjectScoreDict(weekKey,latestData.mineralScore            ),
            caScore:    createObjectScoreDict(weekKey,latestData.caScore            ),
            mgScore:   createObjectScoreDict(weekKey,latestData.mgScore            ),
            feScore:   createObjectScoreDict(weekKey,latestData.feScore            ),
            phScore:   createObjectScoreDict(weekKey,latestData.phScore            ),
            probioticsScore: createObjectScoreDict(               weekKey,latestData.probioticsScore            ),
            lTheanineScore: createObjectScoreDict(               weekKey,latestData.lTheanineScore            ),
            policoSanolScore: createObjectScoreDict(               weekKey,latestData.policoSanolScore            ),
            omega3Score:   createObjectScoreDict(             weekKey,latestData.omega3Score            ),
            redYeastRice:   createObjectScoreDict(             weekKey,latestData.redYeastRice            ),
            nutrientScore: createObjectScoreDict(               weekKey,latestData.nutrientScore            ),
            wellnessScore: createObjectScoreDict(               weekKey,latestData.wellnessScore            ),
            skinHealthScore: createObjectScoreDict(               weekKey,latestData.skinHealthScore            ),
            cleanserScore:   createObjectScoreDict(             weekKey,latestData.cleanserScore            ),
            moisturizerScore:  createObjectScoreDict(              weekKey,latestData.moisturizerScore            ),
            sunScreenScore:  createObjectScoreDict(              weekKey,latestData.sunScreenScore            ),
            exfoliantsScore: createObjectScoreDict(               weekKey,latestData.exfoliantsScore            ),
            antiAgingScore:  createObjectScoreDict(              weekKey,latestData.antiAgingScore            ),
            brighteningScore: createObjectScoreDict(               weekKey,latestData.brighteningScore            ),
            acneScore:     createObjectScoreDict(           weekKey,latestData.acneScore            ),
            soothingScore:   createObjectScoreDict(             weekKey,latestData.soothingScore            ),
        }
        let weeklyDocRef = await addDoc(weeklyRef,weeklyLog)
        const userRef = doc(db,"users",latestData.userID);
        await updateDoc(userRef,{
            weeklyDoc:weeklyDocRef.id,
        })
    }
}

export const fetchDataForNav = async()=>{
    let respObj = {
        status:false,
        data:[],
        summary:0
    }
    let navResp = await new Promise((resolve,reject)=>{
        onAuthStateChanged(auth,async(user)=>{
            if(user){
                let checkAuth = await getSubscriptionInfo();
                if (checkAuth.status){
                    let customerID = localStorage.getItem('customerID')
                    const userRef = doc(db,"users",customerID);
                    const userSnap = await getDoc(userRef);
                    if(userSnap.exists()){
                        let latestRecord = userSnap.data().prevDoc;
                        if(latestRecord.length !== 0){
                            const rRef = doc(db,"p2_results",latestRecord);
                            const rSnap = await getDoc(rRef);// set verified for the record to true
                            if (rSnap.exists()){
                                let summr = Number(averageValue([rSnap.data().healthnessScore,rSnap.data().wellnessScore,rSnap.data().skinHealthScore]).toFixed(1));
                                respObj = {
                                    status:true,
                                    data:[
                                        rSnap.data()
                                    ],
                                    summary:summr
                                }
                            }else{
                                respObj = {
                                    status:false,
                                    summary:0,
                                    data:[]
                                }
                            }
                        }else{
                            respObj = {
                                status:false,
                                summary:0,
                                data:[]
                            }
                        }
                    }else{
                        respObj = {
                            status:false,
                            summary:0,
                            data:[]
                        }
                    }
                }else{
                    respObj = {
                        status:false,
                        summary:0,
                        data:[]
                    }
                }
            }
            resolve(respObj)
        })
    })
    respObj = navResp;
    return respObj
}

/// prevDoc will be verified records and resultDoc will be unverified records
export const fetchLatestScore = async(feature,featureText)=>{ // edits to be made for healthiness , wellness and skin health main score
    let score = 0;
    let scoreString = "";
    let latestRecord = '';
    let scorePercent = 1;
    let latestScanTime = '';
    let reconScore = 0;
    let latestResp = await new Promise((resolve,reject)=>{
        onAuthStateChanged(auth,async(user)=>{
            if(user){
                let checkAuth = await getSubscriptionInfo();
                if (checkAuth.status){
                    let customerID = localStorage.getItem('customerID')
                    const userRef = doc(db,"users",customerID);
                    const userSnap = await getDoc(userRef);
                    if(userSnap.exists()){
                        latestRecord = userSnap.data().prevDoc;
                        if(latestRecord.length !== 0){
                            const rRef = doc(db,"p2_results",latestRecord);
                            const rSnap = await getDoc(rRef);// set verified for the record to true
                            if (rSnap.exists()){
                                // console.log('HR Score : ',rSnap.data().hrScore);
                                // score = rSnap.data().hrScore;
                                latestScanTime = `${rSnap.data().date} ${rSnap.data().time}`
                                // if(feature === 0){
                                //     score = rSnap.data().healthnessScore;
                                // }else 
                                if(feature === 1){
                                    score = rSnap.data().basicScore;
                                }else if (feature ===2){
                                    score = rSnap.data().hrScore;
                                }else if (feature === 3){
                                    score = rSnap.data().spo2Score;
                                }else if (feature === 4){
                                    score = rSnap.data().rrScore;
                                }else if (feature === 5){
                                    score = rSnap.data().coreScore;
                                }else if (feature === 6){
                                    score = rSnap.data().bpScore;
                                }else if (feature === 7){
                                    score = rSnap.data().bsScore;
                                }else if (feature === 8){
                                    score = rSnap.data().bcScore;
                                }else if (feature === 9){
                                    score = rSnap.data().healthTipScore;
                                }
                                // else if (feature === 10){
                                //     score = rSnap.data().wellnessScore;
                                // }
                                else if (feature === 11){
                                    score = rSnap.data().fitnessScore;
                                }else if (feature === 12){
                                    score = rSnap.data().stressScore;
                                }else if (feature === 13){
                                    score = rSnap.data().fatigueScore;
                                }else if (feature === 14){
                                    score = rSnap.data().boneScore;
                                }else if (feature === 15){
                                    score = rSnap.data().immuneScore;
                                }else if (feature === 16){
                                    score = rSnap.data().metabolismScore;
                                }else if (feature === 17){
                                    score = rSnap.data().glucoseMetabolismScore;
                                }else if (feature === 18){
                                    score = rSnap.data().cholMetabolismScore;
                                }else if (feature === 19){
                                    score = rSnap.data().o2MetabolismScore;
                                }else if (feature === 20){
                                    score = rSnap.data().easternMedicineScore;
                                }else if (feature === 21){
                                    score = rSnap.data().yangScore;
                                }else if (feature === 22){
                                    score = rSnap.data().sensitivityScore;
                                }else if (feature === 23){
                                    score = rSnap.data().circulationScore;
                                }else if (feature === 24){
                                    score = rSnap.data().dietScore;
                                }else if (feature === 25){
                                    score = rSnap.data().vitaminScore;
                                }else if (feature === 26){
                                    score = rSnap.data().vitaBScore;
                                }else if (feature === 27){
                                    score = rSnap.data().vitaB3Score;
                                }else if (feature === 28){
                                    score = rSnap.data().vitaB9Score;
                                }else if (feature === 29){
                                    score = rSnap.data().vitaB12Score;
                                }else if (feature === 30){
                                    score = rSnap.data().vitaCScore;
                                }else if (feature === 31){
                                    score = rSnap.data().vitaDScore;
                                }else if (feature === 32){
                                    score = rSnap.data().vitaEScore;
                                }else if (feature === 33){
                                    score = rSnap.data().mineralScore;
                                }else if (feature === 34){
                                    score = rSnap.data().mgScore;
                                }else if (feature === 35){
                                    score = rSnap.data().caScore;
                                }else if (feature === 36){
                                    score = rSnap.data().feScore;
                                }else if (feature === 37){
                                    score = rSnap.data().phScore;
                                }else if (feature === 38){
                                    score = rSnap.data().nutrientScore;
                                }else if (feature === 39){
                                    score = rSnap.data().probioticsScore;
                                }else if (feature === 40){
                                    score = rSnap.data().lTheanineScore;
                                }else if (feature === 41){
                                    score = rSnap.data().policoSanolScore;
                                }else if (feature === 42){
                                    score = rSnap.data().omega3Score;
                                }else if (feature === 43){
                                    score = rSnap.data().redYeastRice;
                                }
                                // else if (feature === 44){
                                //     score = rSnap.data().skinHealthScore;
                                // }
                                else if (feature === 45){
                                    score = rSnap.data().cleanserScore;
                                }else if (feature === 46){
                                    score = rSnap.data().moisturizerScore;
                                }else if (feature === 47){
                                    score = rSnap.data().sunScreenScore;
                                }else if (feature === 48){
                                    score = rSnap.data().exfoliantsScore;
                                }else if (feature === 49){
                                    score = rSnap.data().antiAgingScore;
                                }else if (feature === 50){
                                    score = rSnap.data().brighteningScore;
                                }else if (feature === 51){
                                    score = rSnap.data().acneScore;
                                }else {
                                    score = rSnap.data().soothingScore;
                                }
                                scorePercent = Number(((score / 3.0) * 100).toFixed(1));
                                if((score >= 1)&&(score <2)){
                                    scoreString="Bad";
                                    reconScore = 3;
                                }else if ((score >= 2)&&(score <3)){
                                    scoreString="Fair";
                                    reconScore = 2;
                                }else if (score === 3){
                                    scoreString="Good";
                                    reconScore = 1;
                                }
                            }
                        }
                    }
                }
            }
            let recID = `${featureText}_${Math.round(reconScore)}`;
            let recommend = await fetchRecommendation(recID);
            // let resp = {score:score,recordID:latestRecord,scoreText:scoreString,scorePercentage:scorePercent,recommend:recommend,time:latestScanTime}
            resolve({score:score,recordID:latestRecord,scoreText:scoreString,scorePercentage:scorePercent,recommend:recommend,time:latestScanTime})
        })
    })
    return latestResp
}

const calculateHealthinessRatio = (score)=>{// values 1.0 means 100 , 3.0 means 130 - ratio out of 130 
    let ratio = Number((((score - 1) / 2) * 30 + 100).toFixed(1));
    let text = "";
    let percentValue = Number(((score / 3.0) * 100).toFixed(1));
    if ((ratio >= 100) && (ratio < 110)){
        text = "Bad";
    }else if ((ratio >= 110) && (ratio < 120)){
        text = "Fair";
    }else {
        text = "Good";
    }
    return [ratio,text,percentValue]
}

const calculateWellnessRatio = (score)=>{ // values 1.0 means 50 , 3.0 means 80 - ratio out of 80 
    let ratio = Number((((score - 1) / 2) * 30 + 50).toFixed(1));
    let text = "";
    let percentValue = Number(((score / 3.0) * 100).toFixed(1));
    if ((ratio >= 50) && (ratio < 60)){
        text = "Bad";
    }else if ((ratio >= 60) && (ratio < 70)){
        text = "Fair";
    }else {
        text = "Good";
    }
    return [ratio,text,percentValue]
}

const calculateSkinHealthRatio = (score)=>{ // values 1.0 means 0 , 3.0 means 30 - ratio out of 30 
    let ratio = Number((((score - 1) / 2) * 30).toFixed(1));
    let text = "";
    let percentValue = Number(((score / 3.0) * 100).toFixed(1));
    if ((ratio >= 0) && (ratio < 10)){
        text = "Bad";
    }else if ((ratio >= 10) && (ratio < 20)){
        text = "Fair";
    }else {
        text = "Good";
    }
    return [ratio,text,percentValue]
}

export const fetchLatestMainScore = async()=>{ // edits to be made for healthiness , wellness and skin health main score
    let healthnessScore = -1;
    let wellnessScore = -1;
    let skinHealthScore = -1;
    let hscoreString = "";
    let wscoreString = "";
    let sscoreString = "";
    let latestRecord = '';
    let latestScanTime = '';
    let hPercent = 0;
    let wPercent = 0;
    let sPercent = 0;
    let mainResp = await new Promise((resolve,reject)=>{
        onAuthStateChanged(auth,async(user)=>{
            if(user){
                let checkAuth = await getSubscriptionInfo();
                if (checkAuth.status){
                    let customerID = localStorage.getItem('customerID')
                    const userRef = doc(db,"users",customerID);
                    const userSnap = await getDoc(userRef);
                    if(userSnap.exists()){
                        latestRecord = userSnap.data().prevDoc; // latest verified record
                        if(latestRecord.length !== 0){
                            const rRef = doc(db,"p2_results",latestRecord);
                            const rSnap = await getDoc(rRef);
                            if (rSnap.exists()){
                                latestScanTime = `${rSnap.data().date} ${rSnap.data().time}`
                                healthnessScore = rSnap.data().healthnessScore; 
                                let hRatio = calculateHealthinessRatio(healthnessScore);
                                healthnessScore = hRatio[0];
                                hscoreString = hRatio[1];
                                hPercent = hRatio[2];
                                wellnessScore = rSnap.data().wellnessScore;
                                let wRatio = calculateWellnessRatio(wellnessScore);
                                wellnessScore = wRatio[0];
                                wscoreString = wRatio[1];
                                wPercent = wRatio[2];
                                skinHealthScore = rSnap.data().skinHealthScore;
                                let sRatio = calculateSkinHealthRatio(skinHealthScore);
                                skinHealthScore = sRatio[0];
                                sscoreString = sRatio[1];
                                sPercent = sRatio[2];
                            }
                        }
                    }
                
                }
            }
            // let resp = {hScore:healthnessScore,wScore:wellnessScore,sScore:skinHealthScore,hPercent:hPercent,wPercent:wPercent,sPercent:sPercent,recordID:latestRecord,hText:hscoreString,wText:wscoreString,sText:sscoreString,time:latestScanTime}
            resolve({hScore:healthnessScore,wScore:wellnessScore,sScore:skinHealthScore,hPercent:hPercent,wPercent:wPercent,sPercent:sPercent,recordID:latestRecord,hText:hscoreString,wText:wscoreString,sText:sscoreString,time:latestScanTime})
        })
    })
    return mainResp
}

const dayOfWeek = (date) => {
    // Get the date object for the specified date
    const d = new Date(date);
  
    // Get the day of the week (0 = Sunday, 1 = Monday, etc.)
    const dateDay = d.getDay();
    // Calculate the start and end dates
    const startDate = new Date(d);
    startDate.setDate(startDate.getDate() + (dateDay === 0 ? 0 : -dateDay)); // 
    // startDate.setDate(startDate.getDate() - dateDay + (dateDay === 0 ? 6 : -1)); // 26 - 0 +6 = 32
    const endDate = new Date(d);
    endDate.setDate(endDate.getDate() + (dateDay === 6 ? 0 : 6 - dateDay));
  
    // Format the start and end dates as strings
    const startYear = startDate.getFullYear();
    const startMonth = (startDate.getMonth() + 1).toString().padStart(2, '0');
    const startDay = startDate.getDate().toString().padStart(2, '0');
    const endYear = endDate.getFullYear();
    const endMonth = (endDate.getMonth() + 1).toString().padStart(2, '0');
    const endDay = endDate.getDate().toString().padStart(2, '0');
    const startDateStr = `${startYear}-${startMonth}-${startDay}`;
    const endDateStr = `${endYear}-${endMonth}-${endDay}`;
  
    // Return the start and end dates, as well as the current day of the week
    return { start: startDateStr, end: endDateStr, currDay: dateDay };
};
  

function averageValue(arr){
    var total = 0;
    var count = 0;
    arr.forEach((item, index)=>{
        total+=item;
        count++;
    });
    return total/count;
}

const getGraphDataFromScoreDict = (scoreDict)=>{
    let graph_data = []
    let daysList = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    let score_data = [];
    for (let key in scoreDict){
        let dicts = {}
        if (scoreDict[key] != 0){
            // dicts[daysList[key]]=scoreDict[key]
            dicts = {
                x:daysList[key],
                y:scoreDict[key]
            }
            graph_data.push(dicts)
            score_data.push(scoreDict[key])
        }
    }
    let avg_score = Number(averageValue(score_data).toFixed(1))
    let weekColor='';
    if ((avg_score >= 1) && (avg_score <2)){
        weekColor = "rgb(219, 61, 33)";
    }else if ((avg_score >=2 ) && (avg_score < 3)){
        weekColor = "rgb(213, 219, 33)";
    }else{
        weekColor = "rgb(61,219,33)";
    }
    let weeklyAvg = [{x:'Sunday',y:avg_score},{x:'Monday',y:avg_score},{x:'Tuesday',y:avg_score},{x:'Wednesday',y:avg_score},{x:'Thursday',y:avg_score},{x:'Friday',y:avg_score},{x:'Saturday',y:avg_score}]
    return [graph_data,weeklyAvg,weekColor]
}

const getGraphDataFromMainScoreDict = (scoreDict,mode)=>{
    let graph_data = []
    let daysList = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    for (let key in scoreDict){
        let dicts = {}
        if (scoreDict[key] != 0){
            let scoreVal = 0;
            if (mode == '0'){ // healthness
                scoreVal = calculateHealthinessRatio(scoreDict[key])[0]
            }else if (mode == '1'){ // wellness
                scoreVal = calculateWellnessRatio(scoreDict[key])[0]
            }else{
                scoreVal = calculateSkinHealthRatio(scoreDict[key])[0]
            }
            // dicts[daysList[key]]=scoreVal
            dicts = {
                x: daysList[key],
                y: scoreVal
            }
            graph_data.push(dicts)
        }
    }
    return graph_data
}

export const fetchWeeklyData = async(feature,chartLabel)=>{ // make function general and make function accept date value for filtering as well
    let graph_resp=[]
    let graphResp = await new Promise((resolve,reject)=>{
        onAuthStateChanged(auth,async(user)=>{
            if(user){
                let checkAuth = await getSubscriptionInfo();
                if (checkAuth.status){
                    let customerID = localStorage.getItem('customerID')
                    let userDocRef = doc(db,'users',customerID)
                    let userSnapShot = await getDoc(userDocRef)
                    let weekDocID = userSnapShot.data().weeklyDoc
                    let weekDocRef = doc(db,'weekly_data',weekDocID)
                    let weekSnapShot = await getDoc(weekDocRef)
                    let weeklyData = weekSnapShot.data()
                    if(feature === 0){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.healthnessScore);
                    }else if(feature === 1){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.basicScore);
                    }else if (feature ===2){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.hrScore);
                    }else if (feature === 3){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.spo2Score);
                    }else if (feature === 4){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.rrScore);
                    }else if (feature === 5){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.coreScore);
                    }else if (feature === 6){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.bpScore);
                    }else if (feature === 7){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.bsScore);
                    }else if (feature === 8){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.bcScore);
                    }else if (feature === 9){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.healthTipScore);
                    }else if (feature === 10){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.wellnessScore);
                    }else if (feature === 11){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.fitnessScore);
                    }else if (feature === 12){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.stressScore);
                    }else if (feature === 13){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.fatigueScore);
                    }else if (feature === 14){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.boneScore);
                    }else if (feature === 15){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.immuneScore);
                    }else if (feature === 16){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.metabolismScore);
                    }else if (feature === 17){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.glucoseMetabolismScore);
                    }else if (feature === 18){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.cholMetabolismScore);
                    }else if (feature === 19){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.o2MetabolismScore);
                    }else if (feature === 20){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.easternMedicineScore);
                    }else if (feature === 21){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.yangScore);
                    }else if (feature === 22){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.sensitivityScore);
                    }else if (feature === 23){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.circulationScore);
                    }else if (feature === 24){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.dietScore);
                    }else if (feature === 25){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaminScore);
                    }else if (feature === 26){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaBScore);
                    }else if (feature === 27){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaB3Score);
                    }else if (feature === 28){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaB9Score);
                    }else if (feature === 29){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaB12Score);
                    }else if (feature === 30){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaCScore);
                    }else if (feature === 31){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaDScore);
                    }else if (feature === 32){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.vitaEScore);
                    }else if (feature === 33){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.mineralScore);
                    }else if (feature === 34){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.mgScore);
                    }else if (feature === 35){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.caScore);
                    }else if (feature === 36){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.feScore);
                    }else if (feature === 37){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.phScore);
                    }else if (feature === 38){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.nutrientScore);
                    }else if (feature === 39){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.probioticsScore);
                    }else if (feature === 40){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.lTheanineScore);
                    }else if (feature === 41){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.policoSanolScore);
                    }else if (feature === 42){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.omega3Score);
                    }else if (feature === 43){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.redYeastRice);
                    }else if (feature === 44){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.skinHealthScore);
                    }else if (feature === 45){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.cleanserScore);
                    }else if (feature === 46){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.moisturizerScore);
                    }else if (feature === 47){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.sunScreenScore);
                    }else if (feature === 48){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.exfoliantsScore);
                    }else if (feature === 49){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.antiAgingScore);
                    }else if (feature === 50){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.brighteningScore);
                    }else if (feature === 51){
                        graph_resp = getGraphDataFromScoreDict(weeklyData.acneScore);
                    }else{
                        graph_resp = getGraphDataFromScoreDict(weeklyData.soothingScore);
                    }
                }
            }
            resolve(graph_resp)
        })
    })
    graph_resp=graphResp
    let weeklyAvg = graph_resp[1]
    let graphData = graph_resp[0]
    let weekColor = graph_resp[2]
    return [weeklyAvg,graphData,weekColor,chartLabel]
}

export const fetchWeeklyMainData = async()=>{ 
    let graph_resp=[]
    let mainGraphResp = await new Promise((resolve,reject)=>{
        onAuthStateChanged(auth,async(user)=>{
            if(user){
                let checkAuth = await getSubscriptionInfo();
                if (checkAuth.status){
                    let customerID = localStorage.getItem('customerID')
                    let userDocRef = doc(db,'users',customerID)
                    let userSnapShot = await getDoc(userDocRef)
                    let weekDocID = userSnapShot.data().weeklyDoc
                    let weekDocRef = doc(db,'weekly_data',weekDocID)
                    let weekSnapShot = await getDoc(weekDocRef)
                    let weeklyData = weekSnapShot.data()
                    let hgraphData = getGraphDataFromMainScoreDict(weeklyData.healthnessScore,'0')
                    let wgraphData = getGraphDataFromMainScoreDict(weeklyData.wellnessScore,'1')
                    let sgraphData = getGraphDataFromMainScoreDict(weeklyData.skinHealthScore,'2')
                    graph_resp = [hgraphData,wgraphData,sgraphData]
                }
            }
            resolve(graph_resp)
        })
    })
    graph_resp=mainGraphResp
    let hgraphData = graph_resp[0]
    let wgraphData = graph_resp[1]
    let sgraphData = graph_resp[2]
    return [hgraphData,wgraphData,sgraphData]
}
